/*
 * SpecB2B pricing panel on Warehouse's product page.
 *
 * Quantity picks a price tier from Blazon's ladder (already resolved per
 * break, in cents), so nothing here decides a price. The variant comes from
 * Warehouse's own picker: it fires a bubbling "variant:change", and the chosen
 * variant is handed to Blazon through data-variant-id so the design tool opens
 * on what the customer picked.
 */
(function () {
  "use strict";
  var panel = document.querySelector("[data-sb-panel]");
  if (!panel) return;

  var published = JSON.parse(panel.querySelector("[data-sb-pricing]").textContent || "null");
  if (!published) return;
  // The ladder in force: a product can cost different money in different
  // sizes, and the panel must show the size the customer is looking at.
  var pricing = published;
  var fmt = new Intl.NumberFormat(panel.dataset.locale || undefined, {
    style: "currency", currency: panel.dataset.currency || "USD",
  });
  var money = function (cents) { return fmt.format(cents / 100); };
  var qtyInput = panel.querySelector("[data-sb-qty]");
  var blazon = panel.querySelector("[data-blazon-root]");
  var moq = pricing.moq || 1;

  /** The ladder for a variant: its own when the product prices sizes apart. */
  function ladderFor(variant) {
    if (!published.by_variant || !variant || !variant.options) return published;
    var index = -1;
    (panel.dataset.optionNames || "").split("|").forEach(function (name, i) {
      if (name && published.option && name.toLowerCase() === published.option.toLowerCase()) index = i;
    });
    var value = index >= 0 ? variant.options[index] : null;
    var ladder = value && published.by_variant[value];
    if (!ladder) return published;
    return { moq: published.moq, base_cents: ladder.base_cents, from_cents: ladder.from_cents, tiers: ladder.tiers };
  }

  function applyLadder(variant) {
    var next = ladderFor(variant);
    if (next === pricing) return;
    pricing = next;
    // The tier table is server-rendered from the product ladder, so its cells
    // are rewritten when a size carries its own prices.
    var cells = panel.querySelectorAll("[data-sb-tiers] .sb-tier");
    cells.forEach(function (cell, i) {
      var tier = pricing.tiers[i];
      if (!tier) { cell.hidden = true; return; }
      cell.hidden = false;
      cell.dataset.min = tier.min;
      cell.dataset.max = tier.max === null ? "" : tier.max;
      cell.dataset.price = tier.price_cents;
      cell.querySelector(".sb-tier__range").textContent = tier.max === null ? tier.min + "+" : tier.min + "–" + tier.max;
      cell.querySelector(".sb-tier__price").textContent = money(tier.price_cents);
    });
    render();
  }

  document.addEventListener("variant:change", function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    if (blazon) blazon.dataset.variantId = v.id;
    applyLadder(v);
  });

  function tierFor(q) {
    for (var i = 0; i < pricing.tiers.length; i++) {
      var t = pricing.tiers[i];
      if (q >= t.min && (t.max === null || q <= t.max)) return { tier: t, index: i };
    }
    return null;
  }
  function readQty() {
    var q = parseInt(qtyInput.value, 10);
    return Number.isInteger(q) && q > 0 ? q : moq;
  }

  function render() {
    var q = readQty();
    var hit = tierFor(q);
    var unit = hit ? hit.tier.price_cents : pricing.base_cents;
    panel.querySelectorAll("[data-sb-tiers] .sb-tier").forEach(function (cell, i) {
      cell.classList.toggle("is-active", !!hit && i === hit.index);
    });
    panel.querySelector("[data-sb-qty-label]").textContent = q.toLocaleString();
    panel.querySelector("[data-sb-unit]").textContent = money(unit);
    panel.querySelector("[data-sb-total]").textContent = money(unit * q);
    // Against the price at the MINIMUM order, not at one unit: on a product
    // with a 200-unit minimum, "vs. 1 unit" compares with a price nobody can
    // buy. The first band IS the entry price.
    var entry = (pricing.tiers[0] && pricing.tiers[0].price_cents) || pricing.base_cents;
    var save = Math.round((1 - unit / entry) * 100);
    var saveEl = panel.querySelector("[data-sb-save]");
    saveEl.hidden = save <= 0;
    panel.querySelector("[data-sb-save-pct]").textContent = save;
    var saveBase = panel.querySelector("[data-sb-save-base]");
    if (saveBase) {
      var entryQty = (pricing.tiers[0] && pricing.tiers[0].min) || moq;
      saveBase.textContent = entryQty === 1 ? "1 unit" : entryQty.toLocaleString() + " units";
    }
    var nudge = panel.querySelector("[data-sb-nudge]");
    var next = hit && pricing.tiers[hit.index + 1];
    if (next && next.price_cents < unit) {
      nudge.textContent = "Add " + (next.min - q).toLocaleString() + " more → " + money(next.price_cents) + " / unit";
      nudge.hidden = false;
    } else {
      nudge.hidden = true;
    }
  }

  panel.querySelectorAll("[data-sb-step]").forEach(function (b) {
    b.addEventListener("click", function () {
      qtyInput.value = Math.max(moq, readQty() + Number(b.dataset.sbStep));
      render();
    });
  });
  qtyInput.addEventListener("input", render);
  qtyInput.addEventListener("blur", function () {
    if (readQty() < moq) qtyInput.value = moq;
    render();
  });
  panel.querySelectorAll("[data-sb-tiers] .sb-tier").forEach(function (cell) {
    cell.addEventListener("click", function () {
      qtyInput.value = Math.max(moq, Number(cell.dataset.min));
      render();
    });
  });
  render();
})();
